import { render, staticRenderFns } from "./BoxPlot.vue?vue&type=template&id=40c00e54&scoped=true&"
import script from "./BoxPlot.vue?vue&type=script&lang=js&"
export * from "./BoxPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c00e54",
  null
  
)

export default component.exports